import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { theme } from '../../styles/theme';

const HeaderContainer = styled.header`
  background-color: ${theme.colors.background};
  padding: ${theme.spacing.medium} 0;
  border-bottom: 3px solid ${theme.colors.primary};
  box-shadow: 0 2px 4px rgba(0,0,0,0.05);
`;

const NavContent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 16px;
`;

const LogoContext = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

const Logo = styled.img`
  height: 50px;
  width: auto;
`;

const TitleSection = styled.div`
  display: flex;
  flex-direction: column;
`;

const LogoText = styled.h1`
  font-family: ${theme.fonts.heading};
  color: ${theme.colors.text};
  font-size: 1.5rem;
  span {
    color: ${theme.colors.primary};
  }
`;

const SubText = styled.span`
  font-size: 0.8rem;
  color: ${theme.colors.secondary};
  text-transform: uppercase;
  letter-spacing: 1px;
`;

const Header = () => {
  return (
    <HeaderContainer>
      <NavContent>
        <Link to="/">
          <LogoContext>
            <Logo src="/Kovaion_full.jpg" alt="Kovaion Logo" />
            <TitleSection>
              <SubText>AI Maturity Assessment</SubText>
              <LogoText>Enterprise <span>AI</span> Readiness</LogoText>
            </TitleSection>
          </LogoContext>
        </Link>
      </NavContent>
    </HeaderContainer>
  );
};

export default Header;